/* projects/speaker-platform/src/app/pages/admin/messagerie/messagerie.component.scss */
/*# sourceMappingURL=messagerie.component-XUZV7SXH.css.map */
